import { render } from "./CarouselHeatingOfLenta.vue?vue&type=template&id=b867f380&scoped=true"
import script from "./CarouselHeatingOfLenta.vue?vue&type=script&lang=js"
export * from "./CarouselHeatingOfLenta.vue?vue&type=script&lang=js"

import "./CarouselHeatingOfLenta.vue?vue&type=style&index=0&id=b867f380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b867f380"]])

export default __exports__